class UserModel {
  constructor(id = "", email, name, lastName, sex, birthDate, phone, profilePicture, city, state, zipCode, outdoorNumber, street) {
    this.id = id;
    this.name = name;
    this.lastName = lastName;
    this.sex = sex;
    this.birthDate = birthDate;
    this.phone = phone;
    this.email = email;
    this.profilePicture = profilePicture;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.number = outdoorNumber;
    this.street = street;
  }
}

export function validateEmail(email) {
  const regEx = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
  if (!regEx.test(email)) {
    return false
  }
  return true;
}

export function validateZipCode(code){
  const regEx = /\d/;
  if (!regEx.test(code)) {
    return false
  }
  return true;
}

export function validateText(text){
  const regEx = /[ÁÉÍÓÚA-ZÑ]/i;

  if (!regEx.test(text)) {
    return false
  }
  return true;
}

export function validatePhone(phone){
  const regEx = /\d{8,}/;
  if (!regEx.test(phone)) {
    return false
  }
  return true;
}

// Contraseña de 8 caracteres con mayúsculas, minúsculas y números
export function createPassword() {
  const pass = Math.random().toString(36).slice(-4)+ Math.random().toString(36).toUpperCase().slice(-4);
  return pass;
} 

export default UserModel;